import {View} from '@ab/components';
import mainTpl from '../templates/main';
import PropTypes from 'prop-types';
import Card from '../views/card.c';

class Wallet extends View {
    template = mainTpl;

    _swiperRef = swiper => {
        this.swiper = swiper;
    };

    next = () => {
        if (this.swiper) {
            if (this.swiper.isEnd) {
                this.swiper.slideTo(0);
            } else {
                this.swiper.slideNext();
            }
        }
    };

    prev = () => {
        if (this.swiper) {
            if (this.swiper.isBeginning) {
                this.swiper.slideTo(this.swiper.slides.length);
            } else {
                this.swiper.slidePrev();
            }
        }
    };

    setActive = active => {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(active);
        }
    };

    static propTypes = {
        model: PropTypes.object,
        onChange: PropTypes.func,
        title: PropTypes.any,
        component: PropTypes.any,
        cards: PropTypes.any,
    };

    static defaultProps = {
        component: Card,
    };

    static displayName = 'Wallet.Views.Main';
}

export default Wallet;
